function EnumProp(defaultValue, enumType, additionalValues) {
    return {
        default: defaultValue,
        validator: function (v) {
            return enumType[v] !== undefined || (additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.includes(v)) || false;
        }
    };
}

export { EnumProp };
